import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import Raven from 'Raven';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrl } from 'hubspot-url-utils';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { EERIE } from 'HubStyleTokens/colors';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { checkThirdPartyCookies } from '../features/auth/checkThirdPartyCookies';
import { UsageTracker } from '../utils/tracking';
import { hardNavigate } from '../utils/urls';
import UICloseButton from 'UIComponents/button/UICloseButton';
import { useMediaQuery } from '../utils/hooks'; // @ts-expect-error cannot find module

import logoUrl from 'bender-url!../../img/logo/connect-full-logo-color.svg'; // @ts-expect-error cannot find module

import iconUrl from 'bender-url!../../img/logo/connect-infinity-icon-color.svg';
import ThirdPartyCookiesInstructions from './ThirdPartyCookiesInstructions';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';

const SignupLogin = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [signUpClicked, setSignUpClicked] = useState(false);
  const screenNotTiny = useMediaQuery(`(min-width: 350px)`);
  const checkCookiesAndGo = useCallback(goUrl => {
    checkThirdPartyCookies().then(cookiesEnabled => {
      if (cookiesEnabled) {
        hardNavigate(goUrl);
      } else {
        UsageTracker.trackInteraction({
          action: 'Third-party cookies modal opened',
          entryPoint: signUpClicked ? 'signup' : 'login'
        });
        setModalOpen(true);
      }
    }).catch(err => {
      Raven.captureMessage('Third-party cookie test error', {
        extra: {
          message: err.message
        }
      });
      hardNavigate(goUrl);
    });
  }, [signUpClicked]);
  const handleLogin = useCallback(() => {
    setSignUpClicked(false);
    checkCookiesAndGo(`${getFullUrl('app')}/login/?loginRedirectUrl=${encodeURIComponent(window.location.href)}&signupParams=${encodeURIComponent(JSON.stringify(['connect']))}`);
  }, [checkCookiesAndGo]);
  const handleSignup = useCallback(() => {
    setSignUpClicked(true);
    checkCookiesAndGo(`${getFullUrl('app')}/signup-hubspot/connect`);
  }, [checkCookiesAndGo]);
  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [modalOpen && /*#__PURE__*/_jsxs(UIModal, {
      use: "fullscreen",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        style: {
          background: 'transparent'
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "m-top-6",
          children: /*#__PURE__*/_jsx("img", {
            src: screenNotTiny ? logoUrl : iconUrl,
            height: "29px"
          })
        }), /*#__PURE__*/_jsx(UICloseButton, {
          onClick: closeModal,
          size: "extra-large",
          color: EERIE
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(UIEmptyState, {
          titleText: signUpClicked ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.cookieModal.bodySignUp"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.cookieModal.body"
          }),
          primaryContent: /*#__PURE__*/_jsx(ThirdPartyCookiesInstructions, {}),
          secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
            name: "knock-to-join",
            width: "100%"
          }),
          secondaryContentWidth: 200
        })
      })]
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "secondary",
      onClick: handleLogin,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.login"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      onClick: handleSignup,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.signup"
      })
    })]
  });
};

export default SignupLogin;